import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getListVoucher(params) {
	return client.get("api/voucher/getVoucher", {
		params: params,
	});
}

function getDataVoucher(params) {
	return client.get("api/voucher/data", {
		params: params,
	});
}

function exportVoucher(params) {
	return client.get("api/voucher/export", {
		params: params,
	});
}

function processClaimVoucher(params) {
    return client.post("api/voucher/claim", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    })
}

export default {
    getListVoucher,
    exportVoucher,
	getDataVoucher,
	processClaimVoucher,
};